<template>
    <div>
        <TintFullScreen v-bind:active="commentsModalActive" @click.native="tintClicked"/>
        <div class="pos-fix bt-init lt-init rt-init z-index-10 comments-modal-wrapper" v-show="commentsModalActive">
            <div class="wrapper ht-full">
                <div class="wd-full ht-full comments-modal bg-lavender dp-fx fx-dr-col cl-black">
                    <div class="pd-t-20 pd-b-20 pd-l-20 pd-r-20 comments-count bg-solitude cl-black">
                        <div v-if="comments.list.length > 0">
                            <div class="dp-fx fx-al-ct">
                                <div class="fz-16 lh-19 fw-7">{{ comments.list.length }}</div>
                                <div class="mg-l-4 fz-14 fw-4 lh-17">{{ getCommentsTitle() }}</div>
                            </div>
                        </div>
                        <div v-else class="fz-16 fw-7">{{ getCommentsTitle() }}</div>
                    </div>
                    <PostComment />
                    <CommentsList :data="comments" class="pd-b-20"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from "axios";
    import firebase from 'firebase';
    import {mapState} from 'vuex';
    import TintFullScreen from "@/components/TintFullScreen.vue";
    import CommentsList from "@/components/CommentsList.vue";
    import PostComment from "@/components/PostComment.vue";
    const fb = require('../firebaseConfig.js')

    export default {
        name : 'CommentsModal',
        components : {
            TintFullScreen : TintFullScreen,
            CommentsList : CommentsList,
            PostComment : PostComment
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'commentsModalActive', 'comments', 'currentMovie'])
        },
        data: function () {
            return {

            }
        },
        methods: {
            getCommentsTitle(){
                if (this.comments.list.length == 0) {
                    return 'Comments:'
                } else if(this.comments.list.length == 1) {
                    return 'Comment';
                } else {
                    return 'Comments';
                }
            },
            tintClicked(){
                this.$store.dispatch('deactivateCommentsModal');
                this.$store.dispatch('resetComments');
            }
        }
    }
</script>

<style>
    .tp-init{
        top: 0;
    }
    .bt-init{
        bottom: 0;
    }
    .lt-init{
        left: 0;
    }
    .rt-init{
        right: 0;
    }
    .comments-modal-wrapper{
        height: 60%;
    }
    .comments-modal{
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    }
    .comments-count{
        border-bottom: 1px solid #D6E1F3;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    }
</style>